export default {
  setpointEnter: 'Zadať žiaducu hodnotu',
  durationMinusLimit: 'Trvanie – limit',
  realDuration: 'Skutočná doba trvania',
  durationPlusLimit: 'Trvanie + limit',
  totalTime: 'Celkový čas v pásme',
};
